import * as classNames from 'classnames';
import * as React from 'react';
import withStyles, { StyledComponentProps } from 'react-jss';
import responsive from 'src/constants/responsive';
import stylesheet, { directions } from 'src/constants/stylesheet';
import ViewMonitor from 'src/utils/ViewMonitor';
import Image from './Image';

export type OverviewProps = {
  slides: IDto[];
  goTotSLide: (slideNumber: number) => void;
};

const styles = {
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    psition: 'relative',
    height: '100%',
    boxSizing: 'border-box',
    ...stylesheet.PaddingGutter(.5, directions.sides)
  },
  containerPadding: {
    ...stylesheet.PaddingGutter(1, directions.top)
  },
  slideItem: {
    position: 'relative',
    transition: 'opacity .4s ease',
    [responsive.Tablet]: {
      width: `${100 / 3}%`
    },
    [responsive.AfterTablet]: {
      width: `${100 / 4}%`
    }
  },
  figure: {
    ...stylesheet.MarginGutter(.5, directions.sides)
  },
  figurePaddingBottom: {
    ...stylesheet.MarginGutter(1, directions.bottom)
  },
  image: {
    maxWidth: '100%',
    maxHeight: '100%',
    display: 'block'
  },
  imagePlaceHolder: {
    width: '100%',
    height: 0
  },
  link: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    zIndex:1,
  },
  fadeOut: {
    opacity: .4
  }
};
type Props = OverviewProps &
  StyledComponentProps<keyof typeof styles>;

type State = {
  itemHovered?: number;
}

class Overview extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this._HandleMouseEnter = this._HandleMouseEnter.bind(this);
    this._HandleMouseLeave = this._HandleMouseLeave.bind(this);

    this.state = {};
  }

  public render() {
    const { classes, slides, goTotSLide } = this.props;
    const { itemHovered } = this.state;
    const sizes = "(min-width: 680px) and (max-width: 994px) calc(100% / 3)," +
      "(min-width: 995px) calc(100%/4)";

    return (
      <div className={classNames(classes!.container, classes!.containerPadding)}>
        {slides.map((slide, i) => {
          if (slide.type !== "SlideImage") {
            return;
          }

          const slideImage = slide as SlideImageDto;
          const onMouseEnter = () => this.setState(() => ({ itemHovered: i }));
          return (
            <div
              key={i}
              className={
                classNames(
                  classes!.slideItem,
                  (itemHovered !== i && itemHovered !== undefined) ? classes!.fadeOut : '')}
              // tslint:disable-next-line:jsx-no-lambda
              onMouseEnter={onMouseEnter}
              onMouseLeave={this._HandleMouseLeave}
            >
              <figure className={classNames(classes!.figure, classes!.figurePaddingBottom)}>
                <a
                  // tslint:disable-next-line:jsx-no-lambda
                  onClick={() => goTotSLide(i)}
                  className={classes!.link}
                />
                <ViewMonitor rootMargin="300px">
                  {(isIntersecting) => {

                    return isIntersecting ? (
                      <Image
                        className={classes!.image}
                        pictureRef={slideImage.Image}
                        sizes={sizes}
                      />) :
                      <div
                        className={classes!.imagePlaceHolder}
                        style={{ paddingBottom: (slideImage.Image.Height / slideImage.Image.Width * 100) + "%" }}
                      />;
                  }
                  }
                </ViewMonitor>
              </figure>
            </div>);

        })}
      </div>
    );
  }
  private _HandleMouseEnter(n: number) {
    this.setState(() => ({ itemHovered: n }))
  }

  private _HandleMouseLeave() {
    this.setState(() => ({ itemHovered: undefined }))
  }
}

export default withStyles(styles)(Overview);



// WEBPACK FOOTER //
// ./src/components/Overview.tsx